var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionText',{class:[
    'relative w-5 h-5 md:w-6 md:h-6',
    ( _obj = {}, _obj['bubbleIcon after:absolute after:w-2 after:h-2 after:left-4 after:top-[0.2rem] after:bg-purple-500 after:border-dark after:rounded-full'] = _vm.hasCartItems, _obj ) ],attrs:{"aria-label":_vm.$t(_vm.translations.iconAltText),"to":{ name: _vm.ROUTES.CHECKOUT.CART }},on:{"click":function($event){return _vm.trackClick(_vm.HEADER_TRACKING_NAME.CART)}}},[_c('IconShoppingBag',{staticClass:"w-5 h-5 mr-5 md:w-6 md:h-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }